
jQuery(function($) {
  let ctaIsVisible = 0;
  $('.site-header').addClass('cta-hidden');

  $(document).ready(function() {

    var $navToggle = document.getElementById('site-nav-toggle');
    var navToggleRect = $navToggle.getBoundingClientRect();

    $('.site-header').addClass('ready');
    $('.et_pb_section.et_pb_section_0, .story.story-single').css('paddingTop', (navToggleRect.top + navToggleRect.height) + "px");
    
    if ($('body').hasClass('page-studienformular') || $('body').hasClass('page-test-studienformular') || $('body').hasClass('page-studienformular-2') ) {
      //$('#site-header').css('paddingTop', 0);
      console.log("page is studyform");
    } else {
      $('.et_pb_section.et_pb_section_0').addClass('with-noise')
      $('.site-header').addClass('sticky')
    }

    var visibilityLimit = window.innerWidth < 768 ? window.innerHeight * 1.5 : window.innerHeight;

    $(window).on('scroll', function() {
      if(!ctaIsVisible && window.scrollY > visibilityLimit) {
        $('.site-header').removeClass('cta-hidden');
        ctaIsVisible = true;
      } else if(ctaIsVisible && window.scrollY < visibilityLimit) {
        $('.site-header').addClass('cta-hidden');
        ctaIsVisible = false;
      }
    })
  })
})
